(() => {
  const init = (root) => {
    const link = root.querySelector('[data-mh-review-summary]');
    const feed = root.querySelector('[data-mh-reviews-widget]');
    if (!link || !feed || link.dataset.mhProofReady) return;
    link.dataset.mhProofReady = 'true';
    const update = () => {
      const average = feed.querySelector('.jdgm-all-reviews__summary-average');
      const count = feed.querySelector('.jdgm-all-reviews__summary-text');
      const scoreText = average?.textContent.trim();
      const countText = count?.textContent.trim();
      if (!scoreText || !countText) return;
      link.querySelector('[data-mh-review-score]').textContent = scoreText;
      link.querySelector('[data-mh-review-count]').textContent = `${countText} across our products · Judge.me →`;
    };
    const observer = new MutationObserver(update);
    observer.observe(feed, { childList: true, subtree: true, characterData: true });
    update();
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(root)) observer.disconnect();
    }, { once: true });
  };
  document.querySelectorAll('.mh-hp').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('.mh-hp').forEach(init));
})();
